import { useSelector } from 'react-redux'
import { TidalForm } from '@workwave-tidal/form-ui/layout'

import { selectTelematicsSources } from '@/features/domain/account'
import { useConfigureController } from '../hooks/useController'

import { type FormFields, type FormErrors, formFields } from '../formFields'
import { useFormConfig } from '../hooks/useFormConfig'

import { Form } from './Form'

type Props = {
  tenantSource: uui.domain.server.gps.telematics.TenantSource
}

export function Content(props: Props) {
  const { tenantSource } = props
  const sources = useSelector(selectTelematicsSources)
  const formConfig = useFormConfig(sources[tenantSource.sourceId], tenantSource)
  const { ready } = useConfigureController(tenantSource, sources[tenantSource.sourceId])

  if (!ready) return null

  return (
    <TidalForm<FormFields, FormErrors>
      fieldsSpacing={2}
      disableScroll
      config={formConfig}
      fields={formFields}
      name="edit-telematics-tenant-source-credentials-form"
    >
      <Form />
    </TidalForm>
  )
}
